<div class="card hs-main-panel" [hidden]="(isVisible$ | async) === false">
  <hs-panel-header name="measure" [title]="'PANEL_HEADER.MEASURE' | translateHs">
    <extra-title>&nbsp;<span [hidden]="!hsMeasureService.data.multipleShapeMode">{{'MEASURE.multipleShapes' |
        translateHs }}</span></extra-title>
  </hs-panel-header>
  <div class="card-body p-2">
    <div class="btn-group btn-group-toggle" style="margin-bottom: 10px">
      <label class="btn btn-secondary" [ngClass]="{'active': type === 'distance'}" for="hs-measure-distance">
        {{'COMMON.distance' | translateHs }}
        <input type="radio" name="type" id="hs-measure-distance" value="distance" [(ngModel)]="type"
          (ngModelChange)="changeMeasureParams()">
      </label>
      <label class="btn btn-secondary" [ngClass]="{'active': type === 'area'}" for="hs-measure-area">
        {{'COMMON.area' | translateHs }}
        <input type="radio" name="type" id="hs-measure-area" value="area" [(ngModel)]="type"
          (ngModelChange)="changeMeasureParams()">
      </label>
    </div>
    <button class="btn btn-secondary" style="float:right" (click)="clearAll()">{{'COMMON.clear' | translateHs
      }}</button>
    <ul class="list-group">
      <li *ngFor="let measurement of hsMeasureService.data.measurements" class="list-group-item">
        {{measurement?.size}}&nbsp;{{measurement?.unit}}<span *ngIf="measurement?.type === 'Area'"><sup>2</sup></span>
      </li>
    </ul>
  </div>
</div>